// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e8de310","455":"26ae71b2","977":"1f49aabd"}[chunkId] + ".chunk.js";
};